import React from 'react';

import { WhiteBox, Holder, Text, Four04 } from './404Page.styles';

class FourOhFourPage extends React.Component {
  render() {
    return (
      <Holder>
        <WhiteBox>
          <Four04>404</Four04>
          <Text>Oops...Looks like this page doesn't exist.</Text>
        </WhiteBox>
      </Holder>
    );
  }
}

export default FourOhFourPage;
